import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../../component/shared/shared.service';
import { Patient, Search } from '../patient/model/patient';
import { PatientService } from '../patient/service/patient-service.service';
import { Prescription, MAppointmentAfterCall} from '../patient/model/prescription';
import { PrescriptionService } from '../patient/service/prescription.service';
import { ClinicalNotesService } from '../patient/service/clinical-notes.service';
import { DialogAction, ActionMessage } from '../../shared/enum/dialog-action.enum';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.css']
})
export class PrintComponent implements OnInit {
  loading : boolean = false;
  listLoading : boolean = false;
 
  afterCal : MAppointmentAfterCall;
  message : string = "";  
 
  constructor( private _prvSrv :  PrescriptionService, private _usrService : PatientService, private route: ActivatedRoute, private _clSrv: ClinicalNotesService) { 
    this.afterCal = new  MAppointmentAfterCall(null,null,'','','','','','','','',[],[]);
 }

  ngOnInit() {
    
    let id : number;
    let appid : number;
    this.route.params.subscribe(params => {          
      appid = +params['appointmentid'];     
      this.getPrescriptions(appid);
    });
   
  }
 
 
  getPrescriptions(appId : number) : void {
    
     
    this._prvSrv.getAfterCallData(appId).subscribe(data=>{
      
        this.afterCal = data;
        /*setTimeout(function(){
          window.print();
        },2000)*/
    },
    error=>{
      
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/section/print/print.component.ts